import { Abstrap } from '../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'div' };

class EmptyStateText extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-empty-state__text',
            className,
        ];
    }

}

EmptyStateText.propTypes = propTypes;

EmptyStateText.defaultProps = defaultProps;

export default EmptyStateText;
